import { render, staticRenderFns } from "./yeliao_hw.vue?vue&type=template&id=65092294&scoped=true&"
import script from "./yeliao_hw.vue?vue&type=script&lang=js&"
export * from "./yeliao_hw.vue?vue&type=script&lang=js&"
import style0 from "./yeliao_hw.vue?vue&type=style&index=0&id=65092294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65092294",
  null
  
)

export default component.exports